import React, { ComponentProps, useMemo } from 'react'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { SvgIconProps } from 'LuxKit/SvgIcon'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'

type BodyTextBlockProps = ComponentProps<typeof BodyTextBlock>

interface Props {
  inclusion: App.OfferInclusion;
  isHighlighted?: boolean;
  /**
   * @default medium
   */
  size?: BodyTextBlockProps['variant'];
  format?: BodyTextBlockProps['format'];
  colour?: BodyTextBlockProps['colour'];
  lineClamp?: BodyTextBlockProps['lineClamp'];
  /**
   * @default default
   */
  type?: 'default' | 'lux-plus'
  showMinStayDescription?: boolean
  /**
   * Custom icon override - when provided, this will be used instead of the default icon from getOfferFeatureIcon
   */
  iconOverride?: React.ComponentType<SvgIconProps>
}

function OfferInclusionItem({
  inclusion,
  isHighlighted,
  size = 'medium',
  format,
  colour,
  lineClamp,
  type,
  showMinStayDescription,
  iconOverride,
}: Props) {
  const Icon = useMemo(() => iconOverride || getOfferFeatureIcon(inclusion.symbol), [iconOverride, inclusion])
  const highlighted = isHighlighted ?? inclusion.isHighlighted
  const iconColour: SvgIconProps['colour'] = type === 'lux-plus' ? 'lux-plus' : highlighted ? 'highlight-secondary' : undefined
  const minStayDescription = showMinStayDescription ? getInclusionMinStayText(inclusion) : undefined

  return <BodyTextBlock
    variant={size}
    format={format}
    colour={colour}
    lineClamp={lineClamp}
    weight={highlighted ? 'bold' : 'normal'}
    startIcon={<Icon colour={iconColour} data-symbol={inclusion.symbol} />}
  >
    {inclusion.description} {minStayDescription}
  </BodyTextBlock>
}

export default OfferInclusionItem
